import React, { useState, useEffect } from 'react';
import './Home.css';
import darkBgHero from '../assets/images/dark_bg_hero.jpg';
import lightBgHero from '../assets/images/light_bg_hero.jpg';

const Home = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTimeline = () => {
    // Scroll to featured section (timeline)
    const timelineElement = document.getElementById('featured');
    if (timelineElement) {
      timelineElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  };

  return (
    <section 
      className="hero advanced-hero" 
      id="home"
      style={{
        '--dark-bg-image': `url(${darkBgHero})`,
        '--light-bg-image': `url(${lightBgHero})`
      } as React.CSSProperties}
    >
      {/* Logo in upper left corner */}
      <div className="hero-logo">
        <img src="/assets/logos/club-logo.png" alt="ASIMO Technical Club Logo" />
      </div>

      {/* Background Effects */}
      <div className="hero-background-advanced">
        <div className="cosmic-background"></div>
      </div>
      
      {/* Main Content */}
      <div className="hero-content-advanced">
        <div className={`glass-container hero-glass-advanced ${isScrolled ? 'scrolled' : ''}`}>
          {/* Title Section */}
          <div className="hero-title-advanced">
            <div className="title-line-2">
              <span className="main-title gradient-text-advanced">ASIMO</span>
            </div>
            <div className="title-line-3">
              <span className="subtitle-title">THE TECHNICAL CLUB</span>
            </div>
            <div className="title-line-4">
              <span className="college-name-hero">
                Government Engineering College, Samastipur
              </span>
            </div>
          </div>
          
          {/* Subtitle */}
          <div className="hero-subtitle-advanced">
            <span className="subtitle-main">
              Advance step in MultiTech orientation
            </span>
            <span className="subtitle-secondary">
              Innovating Tomorrow, Today
            </span>
          </div>
          
          {/* Button */}
          <div className="hero-buttons-advanced">
            <button className="btn-explore-timeline" onClick={scrollToTimeline}>
              <span className="btn-text">Explore Timeline</span>
              <div className="waterfill-effect"></div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;